import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';
import useClientsEventBookingContext from '../appointments/hooks/useClientsEventBookingContext';
import MobileMenu from './MobileMenu';
import BookingStep1 from '../../images/booking-img-step-1.jpg';
import BookingStep3 from '../../images/booking-img-step-3.jpg';
import VAHeroImage from '../../images/AMSALE_Flagship_Soho.jpg';
import BookingConfirmed from '../../images/booking-step-confirmed-2022.png';
import BookingAuthorization from '../../images/booking_confirm.jpg';
import BookingThankyou from '../../images/booking_thankyou.png';
import AppointmentStepper from './AppointmentStepper';

function ContentContainerLayout({ children }) {
  const { useRouter } = useAppContext();
  const router = useRouter();
  const [image, setImage] = useState(BookingStep1);
  const [video, setVideo] = useState('https://player.vimeo.com/video/481510743?h=d6aaf5d637&amp;badge=0&amp;autoplay=1&loop=1&muted=1&controls=0&amp;player_id=0&amp;app_id=58479');
  const [completedSteps, setCompletedSteps] = useState(0);
  const [showTimer, setShowTimer] = useState(false);
  const { mobileMenuOpen, setMobileMenuOpen } = useClientsEventBookingContext();

  useEffect(() => {
    const getCurrentImage = () => {
      const { location: { pathname } } = router;
      switch (true) {
        case pathname.includes('/onboarding'):
          setVideo(null);
          setCompletedSteps(1);
          return BookingStep1;
        case pathname.includes('/availabilities'):
          setVideo(null);
          setCompletedSteps(2);
          return null;
        case pathname.includes('/event_form'):
          setVideo(null);
          setCompletedSteps(3);
          setShowTimer(true);
          return BookingStep3;
        case pathname.includes('/confirmation'):
          setShowTimer(true);
          setVideo(null);
          setCompletedSteps(4);
          return null;
        case pathname.includes('/confirmed'):
          setVideo(null);
          setShowTimer(false);
          setCompletedSteps(null);
          return BookingConfirmed;
        case pathname.includes('/appointment_form'):
          setVideo(null);
          return BookingStep1;
        case pathname.includes('/client_form'):
          setVideo(null);
          return BookingStep3;
        case pathname.includes('/authorization'):
          setVideo(null);
          return BookingAuthorization;
        case pathname.includes('/canceled'):
          setVideo(null);
          return null;
        case pathname.includes('/thankyou'):
          setVideo(null);
          setCompletedSteps(null);
          return BookingThankyou;
        case pathname.includes('/virtual-appointment'):
          setVideo(null);
          setCompletedSteps(null);
          return VAHeroImage;
        default:
          return null;
      }
    };

    const newImage = getCurrentImage();
    setImage(newImage);
  }, [image, router, setImage]);

  const handleCloseMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);

    setTimeout(() => {
      document.documentElement.classList.remove('sidebar--open');
      document.querySelector('.drawer-overlay').classList.remove('show');
    }, 350);
  };

  return (
    <main className="content-container-layout">
      <CSSTransition
        in={mobileMenuOpen}
        timeout={350}
        classNames="slide-mobilemenu"
        unmountOnExit
      >
        <MobileMenu handleCloseMenu={handleCloseMenu} />
      </CSSTransition>
      <div className="drawer-overlay" onClick={handleCloseMenu} />
      <div className="stepper-wrapper">
        {completedSteps && <AppointmentStepper completedSteps={completedSteps} />}
      </div>
      {showTimer && <div className="show-timer-wrapper" />}
      <div className="booking-content-flex-wrapper">
        <div className="flex-item content-left-item">
          {children}
        </div>
        {image
          && (
            <div className="flex-item side-image">
              <div className="inner-img">
                {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                <img src={image} alt="booking-image" />
              </div>
            </div>
          )}
        {video
          && (
            <div className="flex-item side-image">
              <div className="inner-img">
                {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                <iframe title="main video" src={video} style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }} />
              </div>
            </div>
          )}
      </div>
    </main>
  );
}
export default ContentContainerLayout;
